module.exports = __webpack_public_path__ + "img/BLUE_BACK.c8edaa75.svg";